// extracted by mini-css-extract-plugin
export var phone = "_4b-0";
export var phoneDragging = "_4b-1";